import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import '@dtable/ui-tokens/tokens.css';
import 'antd/dist/reset.css';
// Markdown editor styles — bundles the preview CSS too, so no separate
// react-markdown-preview import is needed. Must load before any page that
// mounts <MDEditor>.
import '@uiw/react-md-editor/markdown-editor.css';
import './styles/global.css';
import { App } from './App';

// Global dayjs plugins — must be registered before any lazy page uses them.
// Otherwise pages that call .fromNow() crash if loaded before the plugin's
// host page (e.g. hitting /payroll/overview before /inbox).
dayjs.extend(relativeTime);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA service worker registration (§6.5) — production only. In dev it
// causes stale caching + intercepts API calls, which breaks login flows.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('SW registration failed:', err);
      });
    });
  } else {
    // In dev: actively unregister any SW from a previous session so it can't
    // serve stale intercepted responses. Also clears caches — otherwise a hard
    // reload isn't enough.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
    if ('caches' in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  }
}
